import { Language } from '@models/Language'
import { getNavigatorCompatibleLocale } from './NavigatorLanguageHelper'

export enum AvailableLanguage {
  EN = 'en',
  ES = 'es',
  GL = 'gl'
}

export const getLanguagesArray = () => {
  const languages: string[] = []

  for (const l in AvailableLanguage) {
    languages.push((AvailableLanguage as any)[l])
  }

  return languages
}

export const getInitialLocale = (): AvailableLanguage => {
  const initialLocale =
    (localStorage.getItem('locale') as AvailableLanguage) ||
    getNavigatorCompatibleLocale() ||
    (import.meta.env.VITE_VUE_APP_I18N_LOCALE as AvailableLanguage) ||
    (import.meta.env.VITE_VUE_APP_I18N_FALLBACK_LOCALE as AvailableLanguage) ||
    'es'

  return initialLocale
}

export const getFallbackLocale = (): AvailableLanguage => {
  const locale =
    (import.meta.env.VITE_VUE_APP_I18N_FALLBACK_LOCALE as AvailableLanguage) ||
    'en'

  return locale
}

export const getLanguage = (locale: AvailableLanguage): Language => {
  const languageTranslationKey = {
    [AvailableLanguage.EN]: 'header.panels.language.english',
    [AvailableLanguage.ES]: 'header.panels.language.spanish',
    [AvailableLanguage.GL]: 'header.panels.language.galician'
  }
  return {
    translationKey: languageTranslationKey[locale],
    code: locale
  }
}
